import { isString } from 'lodash'

interface CreateCLAccountInput {
  name: string
}

interface UpdateCLAccountInput {
  name: string
}

export class CLAccount {
  id: string
  name: string
  deleted: boolean
  createdAt: number
  updatedAt: number

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  get valid():boolean {
    // name
    if(!isString(this.name)) {
      return false;
    }

    let trimmedName = this.name.trim();

    if(trimmedName.length > 50) {
      return false;
    }

    return true;
  }

  toCreateCLAccountInput(): CreateCLAccountInput {
    return {
      name: this.name,
    };
  }

  toUpdateCLAccountInput(): UpdateCLAccountInput {
    return {
      name: this.name,
    };
  }
}
